import { useCallback, useEffect, useState } from 'react';
import { useField } from 'react-final-form';
import { useLazyQuery } from '@apollo/client';
import { FORM_VALUES } from '../utils/helpers/constants';
import { getLandmarksQuery } from '../api/queries';
import { LandmarksQuery } from '../graphql/graphql';
import { Coordinates } from '../providers/GoogleMapsProvider/types';

export const useLandmarks = (
  coordinates: Coordinates,
  initialLocation: Coordinates
) => {
  const { input: cityIdField } = useField(FORM_VALUES.cityId, {
    subscription: { value: true }
  });
  const [locations, setLocations] = useState<LandmarksQuery['landmarks']>([]);

  const landmarksQueryVariables = {
    cityId: cityIdField.value,
    latitude: coordinates?.lat,
    longitude: coordinates?.lng
  };

  const [getLandmarks] = useLazyQuery<LandmarksQuery>(getLandmarksQuery, {
    onCompleted: data => setLocations(data.landmarks),
    variables: landmarksQueryVariables
  });

  const handleLocationDelete = useCallback(
    id => {
      const updatedLocations =
        locations?.filter(location => location.id !== id) || [];
      setLocations(updatedLocations);
    },
    [locations]
  );

  useEffect(() => {
    getLandmarks({
      variables: {
        cityId: cityIdField.value,
        latitude: coordinates?.lat,
        longitude: coordinates?.lng
      }
    });
  }, [cityIdField.value, initialLocation]);

  return {
    locations,
    getLandmarks,
    handleLocationDelete
  };
};
